import React, { MouseEvent } from 'react';

import { Tooltip } from '@mui/material';
import {
  GridActionsCellItem,
  GridRenderCellParams
} from '@mui/x-data-grid-pro';

import { FontAwesomeSvgIcon } from '../../index';
import { DataGridAction } from '../DataGrid';

interface Props {
  action: DataGridAction;
  params: GridRenderCellParams;
}

export const CustomDataGridAction: React.FC<Props> = ({ action, params }) => {
  const tooltip =
    typeof action.tooltipTitle === 'function'
      ? action.tooltipTitle(params.id, params.row)
      : action.tooltipTitle;
  const icon =
    typeof action.icon === 'function'
      ? action.icon(params.id, params.row)
      : action.icon;

  if (action.hidden) {
    return null;
  }

  return (
    <Tooltip key={tooltip} title={tooltip} arrow>
      <GridActionsCellItem
        size="small"
        label={tooltip}
        icon={<FontAwesomeSvgIcon icon={icon} fontSize="small" />}
        onClick={(event: MouseEvent<HTMLButtonElement>) => {
          action.onClick(params.id, params.row, event);
        }}
      />
    </Tooltip>
  );
};
